import React from 'react';

/* THE ONE DIALOG ON THIS SCREEN — Max, 2026-10-08: "khi click delete thì nên có popup kiểu xác
   nhận nhé thay cho cái hiện tại".

   HIS "ko cần pop up" OF THE DAY BEFORE IS NOT CONTRADICTED. That was about EDITING: a form that
   opens over the page to change a line is friction, and the whole sheet was rebuilt to edit in
   place because of it. This is the opposite case — it removes a programme and every row under it,
   it cannot be undone, and what it replaces was a red strip crowded into the toolbar beside Save.

   WRITTEN ONCE because it is opened from two places: the programme's own bar and the list. Two
   copies is how one of them comes to say a different number from the other, which is exactly the
   fault the count exists to avoid. */
export default function GtmDeleteDialog({ t, code, title, rows, photos, busy, onCancel, onConfirm }) {
  return (
    <div className="gtm-modal-back" role="dialog" aria-modal="true"
      onClick={() => !busy && onCancel()}>
      <div className="gtm-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{t('gtm.deleteProgramme')}</h3>
        <p className="gtm-modal-code">{code}{title ? ` — ${title}` : ''}</p>
        {/* THE NUMBER IS THE SERVER'S, counted before this was drawn. "Delete this" and "delete
            this and its 87 rows" are different questions, and the screen cannot answer the
            second one from what it happens to be showing. */}
        <p>{t('gtm.deleteBody', { n: rows, photos: photos || 0 })}</p>
        <p className="gtm-modal-warn">{t('gtm.deleteWarn')}</p>
        <div className="gtm-modal-acts">
          {/* Project Approval's buttons, as the rest of the screen now uses: the red fill is
              that file's `reject`, the one destructive button it draws. */}
          <button type="button" className="pa-btn" disabled={busy} onClick={onCancel}>
            {t('gtm.keepIt')}
          </button>
          <button type="button" className="pa-btn reject" disabled={busy} onClick={onConfirm}>
            {t('gtm.deleteYes')}
          </button>
        </div>
      </div>
    </div>
  );
}
